module.exports = __webpack_public_path__ + "static/img/img_shop_cabinet.baf42b68.png";